import { BulkOperations } from '@openx/components-header/BulkOperations/BulkOperations';
import { useTranslation } from 'react-i18next';
import type { DealAdCategoryProposal } from '../model';

type DealsSensitiveCategoriesBulkOperationsProps = {
  selectedCategories: DealAdCategoryProposal[];
  closeAndUnselect: () => void;
};

export function DealsSensitiveCategoriesBulkOperations({
  selectedCategories,
  closeAndUnselect,
}: DealsSensitiveCategoriesBulkOperationsProps) {
  const { t } = useTranslation();

  return (
    <BulkOperations
      selectedItems={selectedCategories}
      onClose={closeAndUnselect}
      // based on apps/oa-ui/src/modules/inventory/packages/components/PackagesBulkOperations.tsx
      actions={[
        {
          color: 'secondary',
          label: t('Apply'),
          disabled: false,
          loading: false,
          onClick: () => {
            // TODO: EXCH-18744
          },
        },
        {
          color: 'error',
          label: t('Reject'),
          disabled: false,
          loading: false,
          onClick: () => {
            // TODO: EXCH-18744
          },
        },
      ]}
    />
  );
}
